import React, { useEffect } from "react";
import "./styles.css";
import { useNavigate, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { requestActualURL } from "../../../common/features/tinyURL/tinyURLActions";
import Loader from "../../../components/Loader";

const TinyURL = () => {
  let { tinyURLId } = useParams<any>();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const tinyURLLoading = useSelector(
    (state: any) => state.tinyURL.tinyURLLoading
  );
  const tinyURLSuccess = useSelector(
    (state: any) => state.tinyURL.tinyURLSuccess
  );
  const tinyURLFailure = useSelector(
    (state: any) => state.tinyURL.tinyURLFailure
  );
  const tinyURLResponse = useSelector(
    (state: any) => state.tinyURL.MetaResult?.metaDataInfo.responseMessage
  );

  useEffect(() => {
    if (!/\d/.test(tinyURLId as string)) {
      navigate("/restaurant/" + tinyURLId + "/details");
    }
  }, [tinyURLId, navigate]);

  useEffect(() => {
    if (!tinyURLId || !/\d/.test(tinyURLId as string)) return;
    const tinyURLRequest:{      tinyUrl:string
} = {
      tinyUrl: tinyURLId as string,
    };
    dispatch(requestActualURL(tinyURLRequest));
  }, [dispatch, tinyURLId]);

  useEffect(() => {
    if (!tinyURLLoading && tinyURLSuccess && tinyURLResponse) {
      window.open(tinyURLResponse, "_self");
    }
  }, [tinyURLLoading, tinyURLSuccess, tinyURLResponse]);

  return (
    <>
       {tinyURLLoading && (
        <div className="flex-row"> 
          <Loader/>
        </div>
      )}
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "Poppins",
        fontWeight: 500,
        height: "100vh",
      }}
    >
      <div
        style={{ textAlign: "center", fontSize: "0.8em", marginBottom: "40%" }}
      >
        {" "}
        {tinyURLFailure && (
          <p style={{ color: "#525252", fontFamily: "Poppins" }}>
            Link expired..
          </p>
        )}
      </div>
    </div>
        </>
  );
};
export default TinyURL;
